var FormsComponentModule = /** @class */ (function () {
    function FormsComponentModule() {
    }
    return FormsComponentModule;
}());
export { FormsComponentModule };
